import {
  Box, Button, Card, CardContent, Dialog,
  Grid,
  IconButton,
  Tooltip,
  Typography
} from "@mui/material";
import { capitalize, isEmpty } from "lodash";
import { FC, useEffect, useMemo, useState } from "react";
import { ExternalLink } from "../../../icons/external-link";
import { JobSpecContainer } from "../../jobs/JobSpecContainer";

import { withRouter } from "react-router-dom";
import useFetch from "../../../hooks/http/useFetch";
import { axiosInstance } from "../../../services/axios";
import APIActions from "../../apiOnboarding/apiActions";
import TruncatedScrollingText from "../../common/truncatedScrollingText";
import ConfigTablePopup from "../../dashboard/configTablePopup";
import CategoryBar from "../../dashboard/widgetLibrary/categoryBar";
import SeverityDonut from "../../dashboard/widgetLibrary/severityDonut";
import RunHistoryPopup from "./runHistoryPopup";
import { AccountTree, Settings, TerminalOutlined } from "@mui/icons-material";
import WebAssetOutlinedIcon from '@mui/icons-material/WebAssetOutlined';
import Breadcrumb from "../../common/breadcrumb";
import Metrics from "../../common/metrics";
import ModalWrapper from "../../common/modal/wrapper";
import { ApiModalContent } from "../ApiModal";
var format = require("string-template");

export interface IDataTile {
  title: string;
  ComponentToRender?: FC<any>;
  description?: string;
  onClick?: () => void;
  xs?: number;
  md?: number;
}

export const FindingDataRow: FC<IDataTile> = ({
  title,
  ComponentToRender,
  description,
  onClick,
  xs,
  md,
}) => {
  return (
    <Grid item md={md} xs={xs} sx={{ pr: 3, pt: 1 }}>
      <Typography variant={"overline"} sx={{ fontSize: "12px", opacity: 0.6 }}>
        {title}
      </Typography>
      <Typography
        className="hand"
        variant={"h6"}
        onClick={onClick ? onClick : () => { }}
      >
        {onClick ? <ExternalLink fontSize="inherit" /> : null}
        {description}
        {ComponentToRender ? <ComponentToRender /> : null}
      </Typography>
    </Grid>
  );
};

const ResultData: FC<any> = ({
  id,
  api,
  onFaultsGroupChange,
  match,
  Summary,
  location,
  totalIssues,
  riskIssueData
}: any) => {
  const [dialogOpen, setDialogOpen] = useState(false);



  const useQuery = () => new URLSearchParams(location.search);
  const query = useQuery();
  const environmentId = query.get("environmentId");
  const { data: environment } = useFetch(`/environments/${environmentId}`)
  const [configurations, setConfigurations] = useState<any[] | null>(null);
  const breadcrumbsData = useMemo(() => [{
    label: api?.projectName,
    icon: <AccountTree fontSize="inherit" />,
    onClick: () => window.open(`/projects/${api?.projectId}`, "_self"),
    tooltip: "Project"
  }, {
    label: environment?.name,
    icon: <TerminalOutlined fontSize="inherit" />,
    onClick: () => window.open(`/projects/${api?.projectId}?assetid=${api?.id}`, "_self"),
    tooltip: "Environment"
  },
  {
    label: api?.name,
    icon: <WebAssetOutlinedIcon fontSize="inherit" />,
    onClick: () => window.open(`/projects/${api?.projectId}?assetid=${api?.id}`, "_self"),
    tooltip: "Asset"
  }], [api?.id, api?.name, environment?.name, api?.projectId, api?.projectName])

  useEffect(() => {
    if (!isEmpty(api)) {

      if (environmentId) {
        fetchConfigurations();
      }
    }
  }, [api]);

  const fetchConfigurations = async () => {
    try {
      let configurationsResponse = await axiosInstance.get(
        format(
          "/run/configurations?assetId={assetId}&environmentId={environmentId}",
          {
            assetId: api.id,
            environmentId: environmentId,
          }
        )
      );
      setConfigurations(configurationsResponse?.data?.hermitConfigs);
    } catch (error) { }
  };



  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  return (
    <>
      <Dialog maxWidth="lg" onClose={handleDialogClose} open={dialogOpen}>
        <Box sx={{ m: 3 }}>
          <JobSpecContainer id={id} />
        </Box>
      </Dialog>

      <Breadcrumb data={breadcrumbsData} />

      <Box sx={{ pl: 1, mt: 1, display: "flex", alignItems: "flex-start", width: "100%", justifyContent: 'space-between' }}>
        <Box sx={{ display: "flex", alignItems: 'center' }}>
          <Typography variant="h5" >
            {capitalize(api.assetType)} Issues
          </Typography>
        </Box>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: "space-between" }}>
        <Box display={'flex'} sx={{ alignItems: 'bottom' }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              height: "30px",
            }}
          >
            <Typography
              variant="h1"
              sx={{
                fontSize: "4em",
                mr: 1,
                lineHeight: "1em",
                textAlign: "right",
              }}
            >
              {totalIssues}
            </Typography>

          </Box>
          <Box>
            <Box display={'flex'} sx={{ alignItems: 'center' }}>
              <Typography
                variant="body1"
                sx={{
                  textAlign: "left",
                  my: 1,
                  fontSize: "1em",
                  fontWeight: "bold",
                  lineHeight: "1em",

                }}
              >
                Issues

              </Typography>
            </Box>
            <Metrics sx={{ mt: 2 }} data={riskIssueData} />
          </Box>
        </Box>

        <Box sx={{ pr: 2, display: "flex", alignItems: "center" }}>
          {api.assetType === "sift" && <ConfigTablePopup sx={{ width: "100%" }} assetId={api?.id} />}
          <RunHistoryPopup
            sx={{ mt: 1, width: "100%" }}
            assetId={api?.id}
            button
          />
            {api?.assetType === "api" && <ModalWrapper maxWidth="lg" title="Settings" trigger={<Tooltip title="Settings"><Button variant='outlined' size='small' sx={{ color: "text.primary" , borderColor: 'neutral.300', mr:2, minWidth: '45px', mt:1}}><Settings />
                        </Button></Tooltip>} child={<ApiModalContent assetId={api?.id} />} />}
          
          {api.assetType === "sift" && <APIActions
            row={{
              id: api?.id,
            }}
            sx={{ mt: 1, width: "100%" }}
            enabledActions={["SETTINGS"]}
          />}
        </Box>
      </Box>
    </>
  );
};

export default withRouter(ResultData);
